import {
  AfterViewInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  Renderer2,
} from '@angular/core';
import { CalloutProps, calloutStyles } from '@kite_aerolab/shared/components';
import { getBreakpoint } from '@kite_aerolab/shared/utils';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'kite-callout',
  template: `
    <div role="alert" [ngClass]="calloutStyles">
      <div class="callout-center-container">
        <div class="callout-title-container">
          <div class="callout-icon-and-title-container">
          <kite-icon
            class="callout-icon-centered"
            [name]="icon || getStatusIcon()"
            size="md"
            ariaLabel="icon || getStatusIcon() + icon"
          >
          </kite-icon>
            <h2 kiteTitle size="xs">{{ title }}</h2>
          </div>
          <p kiteText *ngIf="description" size="sm" variant="description">{{ description }}</p>
        </div>
        <div #ref class="callout-children-container">
          <ng-content></ng-content>
        </div>
      </div>
      <kite-close-action [css]="{ my: -2, mx: -2 }" (onClick)="onClose.emit($event)" class="callout-close-button">
      </kite-close-action>
    </div>
  `,
})
export class CalloutComponent implements AfterViewInit {
  breakpoint = getBreakpoint();

  @ContentChildren(ButtonComponent) children: QueryList<ButtonComponent>;

  /**
   * Variante del alert. Determina su color e ícono
   */
  @Input() variant: CalloutProps['variant'];
  /**
   * Título del alert.
   */
  @Input() title: CalloutProps['title'];
  /**
   * Descripción del alert.
   */
  @Input() description: CalloutProps['description'];
  /**
   * Ícono del alert (opcional, si no se declara, se pone el default por el status)
   */
  @Input() icon: CalloutProps['icon'];
  /**
   * Determina si tiene o no close button
   */
  @Input() isRemovable: CalloutProps['isRemovable'];
  /**
   * css del componente
   */
  @Input() css: CalloutProps['css'];

  /**
   * Optional click handler
   */
  @Output() onClose: EventEmitter<Event> = new EventEmitter();

  constructor(private renderer: Renderer2) {
    /* Agrega un listener al evento resize para mantener el breakpoint */
    this.renderer.listen('window', 'resize', () => {
      this.changeBreakpoint();
    });
  }

  public get calloutStyles(): string[] {
    return [
      calloutStyles({
        variant: this.variant,
        css: this.css,
      }).className,
    ];
  }

  ngAfterViewInit() {
    this.children.toArray().forEach((item) => {
      item.isBlock = { '@initial': true, '@sm': false };
      item.size = { '@initial': 'md', '@sm': 'sm' };
    });
  }

  /* Selecciona el ícono según la variant del callout */
  getStatusIcon() {
    switch (this.variant) {
      case 'success':
        return 'check';
        break;
      case 'info':
        return 'info';
        break;
      case 'warning':
        return 'warning';
        break;
      case 'error':
        return 'alert';
        break;
      default:
        return 'replace';
    }
  }

  changeBreakpoint() {
    this.breakpoint = getBreakpoint();
  }
}
